import { render } from "./TextContent.vue?vue&type=template&id=1313d05b&ts=true"
import script from "./TextContent.vue?vue&type=script&lang=ts"
export * from "./TextContent.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__